/**
 * App shell: layout (header, footer, scroll) and route-dependent visibility.
 * Renders children (Routes) inside the layout.
 */
import { FC, ReactElement, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import FloatingHelpButton from '../../shared/components/FloatingHelpButton';
import ScrollToTop from '../../shared/components/ScrollToTop';

import Footer from './Footer';
import OneInformaBar from './header/OneInformaBar';
import Transaction from './header/Transaction';

// We fix Footer import because AppLayout is in app/layout/, Footer is in app/layout/Footer.tsx, 
// Wait, Footer.tsx is in `src/app/layout/`. The original import in AppLayout.jsx was `import Footer from './Footer';`.
// I will ensure it matches the correct relative path correctly!

interface AppLayoutProps {
  children: ReactNode;
}

const AppLayout: FC<AppLayoutProps> = ({ children }): ReactElement => {
  const location = useLocation();
  const hideOneInformaBar = ['/checkout', '/invoice-confirmation', '/payment-success', '/order'].some((path) =>
    location.pathname.includes(path)
  );
  const isEventPrivacyPolicy = location.pathname.includes('/event-privacy-policy');
  const showFooter = !location.pathname.includes('/account');

  return (
    <div className="flex flex-col min-h-screen">
      <ScrollToTop />
      {!hideOneInformaBar && !isEventPrivacyPolicy && <OneInformaBar />}
      <Transaction />
      <div className="flex-grow">{children}</div>
      {showFooter && <Footer />}
      <FloatingHelpButton />
    </div>
  );
};

export default AppLayout;
